<ng-container *ngIf="link">
  <ng-container *ngIf="variant === 'topbar'; else drawerTemplate">
    <ng-container *ngIf="hasChildren; else topbarLeaf">
      <button
        type="button"
        mat-button
        #topbarMenuTrigger="matMenuTrigger"
        class="topbarLink topbarLink--menu"
        [class.topbarLink--active]="isActive"
        [class.topbarLink--accentCatalog]="accentName === 'catalog'"
        [class.topbarLink--accent]="accentName === 'parts-selection'"
        [class.topbarLink--accentOrder]="accentName === 'orders'"
        [class.topbarLink--accentProcurement]="accentName === 'procurement'"
        [matMenuTriggerFor]="topbarMenu"
        [matTooltip]="tooltipText"
        [matTooltipDisabled]="!tooltipText"
        matTooltipClass="my-tooltip"
      >
        <span class="topbarLink__label">{{ link.label }}</span>
        <span
          *ngIf="link.badge || link.secondaryBadge"
          class="telephonyBadges"
          [title]="link.badgeTooltip || ''"
        >
          <span *ngIf="link.badge" class="telephonyBadge">{{ link.badge }}</span>
          <span *ngIf="link.secondaryBadge" class="telephonyBadge telephonyBadge--voicemail">{{
            link.secondaryBadge
          }}</span>
        </span>
        <span class="topbarLink__icon" aria-hidden="true">
          <mat-icon>expand_more</mat-icon>
        </span>
      </button>

      <mat-menu #topbarMenu="matMenu" class="shellMenu shellMenu--root">
        <ng-container *ngFor="let child of link.children; trackBy: trackByPath">
          <ng-container *ngIf="!hasNestedChildren(child); else groupedChild">
            <ng-container *ngIf="child.createPath; else childDirectLink">
              <div class="shellMenuRow">
                <a
                  mat-menu-item
                  class="shellMenuItem shellMenuItem--rowLink"
                  [class.shellMenuItem--active]="isItemOrCreateActive(child)"
                  [routerLink]="child.path"
                  (click)="handleNavigate()"
                >
                  <span>{{ child.label }}</span>
                </a>

                <button
                  type="button"
                  mat-icon-button
                  class="shellMenuRow__trigger"
                  [class.shellMenuRow__trigger--active]="isCreatePathActive(child)"
                  [attr.aria-label]="'Создать ' + child.label"
                  (click)="navigateToCreate(child.createPath!, $event, topbarMenuTrigger)"
                >
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </ng-container>

            <ng-template #childDirectLink>
              <a
                mat-menu-item
                class="shellMenuItem"
                [class.shellMenuItem--active]="isItemActive(child)"
                [routerLink]="child.path"
                (click)="handleNavigate()"
              >
                <span>{{ child.label }}</span>
              </a>
            </ng-template>
          </ng-container>

          <ng-template #groupedChild>
            <div
              class="shellMenuGroup"
              (mouseenter)="openGroupedChild(child, groupedChildTriggerElement)"
              (mouseleave)="closeGroupedChild(child)"
            >
              <button
                #groupedChildTriggerElement
                type="button"
                mat-menu-item
                class="shellMenuItem shellMenuItem--group"
                [class.shellMenuItem--active]="
                  isItemOrCreateActive(child) || isGroupedChildOpen(child)
                "
                (click)="toggleGroupedChild(child, $event, groupedChildTriggerElement)"
              >
                <span>{{ child.label }}</span>
                <mat-icon class="shellMenuGroup__triggerIcon">chevron_right</mat-icon>
              </button>

              <div
                *ngIf="isGroupedChildOpen(child)"
                class="shellMenuFlyout"
                [style.top]="openGroupedChildTopOffset"
              >
                <ng-container *ngFor="let nested of child.children; trackBy: trackByPath">
                  <ng-container *ngIf="nested.createPath; else nestedDirectLink">
                    <div class="shellMenuRow">
                      <a
                        mat-menu-item
                        class="shellMenuItem shellMenuItem--rowLink"
                        [class.shellMenuItem--active]="isItemOrCreateActive(nested)"
                        [routerLink]="nested.path"
                        (click)="handleNavigate()"
                      >
                        <span>{{ nested.label }}</span>
                      </a>

                      <button
                        type="button"
                        mat-icon-button
                        class="shellMenuRow__trigger"
                        [class.shellMenuRow__trigger--active]="isCreatePathActive(nested)"
                        [attr.aria-label]="'Создать ' + nested.label"
                        (click)="navigateToCreate(nested.createPath!, $event, topbarMenuTrigger)"
                      >
                        <mat-icon>add</mat-icon>
                      </button>
                    </div>
                  </ng-container>

                  <ng-template #nestedDirectLink>
                    <a
                      mat-menu-item
                      class="shellMenuItem"
                      [class.shellMenuItem--active]="isItemActive(nested)"
                      [routerLink]="nested.path"
                      (click)="handleNavigate()"
                    >
                      <span>{{ nested.label }}</span>
                    </a>
                  </ng-template>
                </ng-container>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </mat-menu>
    </ng-container>

    <ng-template #topbarLeaf>
      <a
        mat-button
        class="topbarLink"
        [class.topbarLink--active]="isActive"
        [class.topbarLink--accentCatalog]="accentName === 'catalog'"
        [class.topbarLink--accent]="accentName === 'parts-selection'"
        [class.topbarLink--accentOrder]="accentName === 'orders'"
        [class.topbarLink--accentProcurement]="accentName === 'procurement'"
        [routerLink]="link.path"
        [matTooltip]="tooltipText"
        [matTooltipDisabled]="!tooltipText"
        matTooltipClass="my-tooltip"
        (click)="handleNavigate()"
      >
        <span class="topbarLink__label">{{ link.label }}</span>
        <span
          *ngIf="link.badge || link.secondaryBadge"
          class="telephonyBadges"
          [title]="link.badgeTooltip || ''"
        >
          <span *ngIf="link.badge" class="telephonyBadge">{{ link.badge }}</span>
          <span *ngIf="link.secondaryBadge" class="telephonyBadge telephonyBadge--voicemail">{{
            link.secondaryBadge
          }}</span>
        </span>
      </a>
    </ng-template>
  </ng-container>

  <ng-template #drawerTemplate>
    <div class="drawerItem" [class.drawerItem--active]="isActive">
      <button
        *ngIf="hasChildren; else drawerLeaf"
        type="button"
        class="drawerLink"
        [class.drawerLink--accent]="accentName === 'parts-selection'"
        [class.drawerLink--accentOrder]="accentName === 'orders'"
        [class.drawerLink--accentProcurement]="accentName === 'procurement'"
        [class.drawerLink--active]="isActive"
        (click)="toggleExpanded()"
      >
        <span>{{ link.label }}</span>
        <mat-icon>{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>

      <ng-template #drawerLeaf>
        <a
          class="drawerLink"
          [class.drawerLink--accent]="accentName === 'parts-selection'"
          [class.drawerLink--accentOrder]="accentName === 'orders'"
          [class.drawerLink--accentProcurement]="accentName === 'procurement'"
          [class.drawerLink--active]="isActive"
          [routerLink]="link.path"
          [matTooltip]="tooltipText"
          [matTooltipDisabled]="!tooltipText"
          matTooltipClass="my-tooltip"
          (click)="handleNavigate()"
        >
          <span>{{ link.label }}</span>
        </a>
      </ng-template>

      <div *ngIf="hasChildren && expanded" class="drawerChildren">
        <ng-container *ngFor="let child of link.children; trackBy: trackByPath">
          <ng-container *ngIf="!hasNestedChildren(child); else drawerGroupedChild">
            <a
              class="drawerChildLink"
              [class.drawerChildLink--active]="isItemActive(child)"
              [routerLink]="child.path"
              (click)="handleNavigate()"
            >
              <span>{{ child.label }}</span>
            </a>
            <a
              *ngIf="child.createPath"
              class="drawerChildLink drawerChildLink--create"
              [routerLink]="child.createPath"
              (click)="handleNavigate()"
            >
              <mat-icon>add</mat-icon>
              <span>Создать {{ child.label }}</span>
            </a>
          </ng-container>

          <ng-template #drawerGroupedChild>
            <div class="drawerSection">
              <div class="drawerSection__title">{{ child.label }}</div>
              <ng-container *ngFor="let nested of child.children; trackBy: trackByPath">
                <a
                  class="drawerChildLink"
                  [class.drawerChildLink--active]="isItemActive(nested)"
                  [routerLink]="nested.path"
                  (click)="handleNavigate()"
                >
                  <span>{{ nested.label }}</span>
                </a>
                <a
                  *ngIf="nested.createPath"
                  class="drawerChildLink drawerChildLink--create"
                  [routerLink]="nested.createPath"
                  (click)="handleNavigate()"
                >
                  <mat-icon>add</mat-icon>
                  <span>Создать {{ nested.label }}</span>
                </a>
              </ng-container>
            </div>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </ng-template>
</ng-container>
